import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const fetchSubscriptions: DocumentNode = gql`
  query fetchSubscriptions {
    listAccountSubscriptions {
      ... on Subscriptions {
        data {
          id
          state
          activatedAt
          trialEndsAt
          pausedAt
          plan {
            name
            code
          }
        }
      }
      ... on SubscriptionsNotFound {
        error {
          type
          message
        }
      }
    }
  }
`

export default fetchSubscriptions
